import { render, staticRenderFns } from "./Zczhcx.vue?vue&type=template&id=136db2ae&scoped=true&"
import script from "./Zczhcx.vue?vue&type=script&lang=js&"
export * from "./Zczhcx.vue?vue&type=script&lang=js&"
import style0 from "./Zczhcx.vue?vue&type=style&index=0&id=136db2ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136db2ae",
  null
  
)

export default component.exports